import { Button } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useRecoilState } from "recoil"
import styled from "styled-components"
import { playerTeams } from "../../App"
import { teams } from "../../data"
import { erase, save } from "../../firebaseConfig"
import { FlexColumnCentered } from "../configure-app"

const AddPLayersWrap = styled(FlexColumnCentered)`
  .save-btn {
    position: fixed;
    top: 5px;
    left: 5px;
  }

  ul {
    column-count: 2;
  }

  li {
    list-style: none;
    border: 1px solid;
    margin: 5px;
    padding: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
`

const Middle = styled.div`
  .active {
    border: 2px solid dodgerblue;
  }
`

const LeftSide = styled.div`
  width: 20vw;
  /* height: 100vh; */
  position: absolute;
  padding-left: 15px;
  left: 0;
  top: 150px;
  border-right: 2px solid;

  li {
  }

  p {
    font-size: 25px;

    margin: 6px 0;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }
`

const RightSide = styled.div`
  width: 20vw;
  /* height: 100vh; */
  position: absolute;
  padding-left: 15px;
  right: 0;
  top: 150px;
  border-left: 2px solid;

  p {
    margin: 1px 0;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }
`

const draftOrder = ["pen", "gla", "cbd", "hur"]
export const AddPlayers = () => {
  const [selTeamId, setSelTeamId] = useState(0)
  const [currentPick, setCurrentPick] = useState(0)
  const [playerTeamsGlobal, setPlayerTeamsG] = useRecoilState(playerTeams)
  const [selTeamName, setSelTeamName] = useState("N/A")
  const [players, setPlayers] = useState([])
  const [selPlayerTeam, setSelPlayerTeam] = useState(draftOrder[currentPick])
  const [playerTeamsLocal, setPlayerTeamsLocal] = useState({
    cbd: [],
    gla: [],
    pen: [],
    hur: [],
  })

  const fetchGuysOnTeam = async (id) => {
    axios({
      method: "get",
      url: `https://statsapi.web.nhl.com/api/v1/teams/${id}?expand=team.roster`,
      // responseType: "stream",
    }).then(function (response) {
      setPlayers(response.data.teams[0].roster.roster)
    })
  }

  useEffect(() => {
    if (selTeamId === -1) return
    fetchGuysOnTeam(selTeamId)
  }, [selTeamId])

  const saveTeams = () => {
    save(playerTeamsLocal)
    window.localStorage.setItem("playerTeams", JSON.stringify(playerTeamsLocal))
    setPlayerTeamsG(playerTeamsLocal)
    // setPlayerTeamsG(playerTeamsLocal);
  }

  const removePlayer = (team, index) => {
    const newTeams = { ...playerTeamsLocal }
    // console.log('🍀🍀', newTeams[team]);
    // if (window.confirm("Remove Player?")) {
    newTeams[team].splice(index, 1)
    setPlayerTeamsLocal(newTeams)
    // }
  }

  const [isUp, setIsUp] = useState(true)
  const [isInit, setIsInit] = useState(true)
  const [isSecond, setIsSecond] = useState(false)

  const handleClickPlayer = (p) => {
    // console.log("i will add", p, "to", selPlayerTeam)
    // console.log(playerTeams[selPlayerTeam])
    // if (window.confirm(`Add ${p.person.fullName} to ${selPlayerTeam}`)) {
    const newTeams = { ...playerTeamsLocal }
    newTeams[selPlayerTeam].push(p)
    // console.log("asdasd", newTeams[selPlayerTeam])
    // console.log({ newTeam })
    setPlayerTeamsLocal(newTeams)
    // setCurrentPick(currentPick < 3 ? currentPick + 1 : 0)
    // setSelPlayerTeam(draftOrder[currentPick < 3 ? currentPick + 1 : 0])
    setPlayerTeamsLocal(newTeams)
    setIsInit(false)
    // set
    // }
  }

  if (!playerTeamsGlobal)
    return (
      <h1>
        <code>!playerTeamsGlobal</code>
      </h1>
    )

  // useEffect(() => {
  //   console.log({ playerTeams })
  // }, [playerTeams])
  return (
    <AddPLayersWrap>
      <LeftSide>
        {teams
          .sort((a, b) => {
            let fa = a.name.toLowerCase(),
              fb = b.name.toLowerCase()

            if (fa < fb) {
              return -1
            }
            if (fa > fb) {
              return 1
            }
            return 0
          })

          .map((t, i) => (
            <p
              key={i}
              onClick={() => {
                setSelTeamId(t.id)
                setSelTeamName(t.name)
              }}
            >
              {t.name}
            </p>
          ))}
      </LeftSide>
      <RightSide>
        <h1>CBD</h1>
        {playerTeamsLocal.cbd.map((p, i) => (
          <p
            onClick={() => {
              removePlayer("cbd", i)
            }}
            key={i}
          >
            {p.person.fullName} ❌
          </p>
        ))}
        <h1>PEN</h1>
        {playerTeamsLocal.pen.map((p, i) => (
          <p
            onClick={() => {
              removePlayer("pen", i)
            }}
            key={i}
          >
            {p.person.fullName} ❌
          </p>
        ))}{" "}
        <h1>GLA</h1>
        {playerTeamsLocal.gla.map((p, i) => (
          <p
            onClick={() => {
              removePlayer("gla", i)
            }}
            key={i}
          >
            {p.person.fullName} ❌
          </p>
        ))}{" "}
        <h1>HUR</h1>
        {playerTeamsLocal.hur.map((p, i) => (
          <p
            onClick={() => {
              removePlayer("hur", i)
            }}
            key={i}
          >
            {p.person.fullName} ❌
          </p>
        ))}
      </RightSide>
      <h1>Set Rosters</h1>
      <Middle>
        <div>
          <Button
            onClick={() => setSelPlayerTeam("pen")}
            className={`${selPlayerTeam === "pen" ? "active" : ""}`}
          >
            🐼
          </Button>
          <Button
            onClick={() => setSelPlayerTeam("gla")}
            className={`${selPlayerTeam === "gla" ? "active" : ""}`}
          >
            🍀
          </Button>
          <Button
            onClick={() => setSelPlayerTeam("cbd")}
            className={`${selPlayerTeam === "cbd" ? "active" : ""}`}
          >
            🦫
          </Button>
          <Button
            onClick={() => setSelPlayerTeam("hur")}
            className={`${selPlayerTeam === "hur" ? "active" : ""}`}
          >
            🎂
          </Button>
        </div>

        <h1>{selTeamName}</h1>
        <ul>
          {players
            .sort((a, b) => {
              let fa = a.person.fullName.toLowerCase(),
                fb = b.person.fullName.toLowerCase()

              if (fa < fb) {
                return -1
              }
              if (fa > fb) {
                return 1
              }
              return 0
            })
            .map((p, i) => {
              return (
                <li key={i} onClick={() => handleClickPlayer(p)}>
                  {p.person.fullName} - {p.position.abbreviation}
                </li>
              )
            })}
        </ul>
      </Middle>
      <div className="save-btn">
        <Button variant="contained" onClick={saveTeams}>
          Save
        </Button>

        <Button variant="contained" onClick={erase}>
          Erase
        </Button>
      </div>
    </AddPLayersWrap>
  )
}
